export default __webpack_public_path__ + "static/media/1_11_logo.fcdcdec5.png";